<template>
	<div class="ms-list">
		<MSScheduleListRow
			v-for="item in sortedAllSchedules"
			v-bind:key="item.schedule.code"
			v-bind:item="item.project"
			v-bind:schedule="item.schedule"
			v-bind:use_talkroom="use_talkroom"
			v-on:progress-rate-setting="progressRateSetting"
		/>
	</div>
</template>
<script>
import MSScheduleListRow from './MSScheduleListRow';
import APIClient from '../classes/APIClient';
export default {
	name: 'MSScheduleList',
	props: ["items"],
	data () {
		return {
			use_talkroom: false,
		}
	},
	methods: {
		progressRateSetting: function(e) {
			this.$emit("progress-rate-setting", e);
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		sortedAllSchedules: function() {
			let target = [];
			this.items.forEach(p => {
				p.schedules.forEach(s => {
					target.push({
						project: p,
						schedule: s,
					});
				});
			});
			target.sort((a, b) => {
				let cmp = a.schedule.compare(b.schedule)
				if (cmp === 0)
					return a.project.seq - b.project.seq;
				return cmp;
			});
			return target;
		},
	},
	components: {
		MSScheduleListRow,
	},
	mounted: function() {
		let api = new APIClient(this.$store);
		api.getContractor()
			.then((res) => {
				this.use_talkroom = res.data.contractor.attr;
			})
			.catch(() => {
				this.logout();
			});
	},
}
</script>
<style>
	.ms-list {
		flex: 0 0 100% !important;
		background-color: white;
		z-index: 101;
	}
</style>
